import React, { useEffect, useState } from "react";
/** @jsxImportSource @emotion/react */
import tw, { styled } from "twin.macro";
import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";
import { useHistory } from "react-router";
import { ROUTES } from "../../settings/routes";
import { DatePicker, Input, Popconfirm, Progress, Radio, Select } from "antd";
import boy_girl from "../../assets/svg/boy_girl.svg";
// import boy_girl_meet from "../../assets/svg/boy_girl_meet.svg";
import user from "../../assets/svg/user.svg";
import location from "../../assets/svg/location.svg";
import calender from "../../assets/svg/calender.svg";
import { btnStyle, inputStyle } from "../../lib/styles/styleLibrary";
import { isEmpty, Toast } from "../../lib/helpers/helpers";
import dayjs from "dayjs";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { getWedding } from "../../redux/reducers/weddingReducer";
import {
	checkUrl,
	createWedding,
	fetchWeddingUrls,
	getTimezone,
	switchExperience,
} from "../../redux/actions/wedding";
import moment from "moment";
import { Loading, PageLoading } from "..";
import { useMutation } from "react-query";

const Wrapper = styled.div`
	${tw`w-full md:w-9/12 max-h-screen`}
	@media (max-width: 1217px) {
		width: 100% !important;
	}
	.label {
		${tw`text-appTextDark opacity-50 font-semibold text-lg`}
	}

	.form-control {
		${tw`pt-3 flex flex-row flex-wrap sm:flex-nowrap items-center justify-between gap-4`}
	}
	.ant-select-selection-search-input {
		padding-top: 15px !important;
	}
	.ant-select-selection-item,
	.ant-select-selection-placeholder {
		padding-top: 10px !important;
		/* color: #dedef0 !important; */
	}
	.ant-select-selection-placeholder {
		color: #db0a0a !important;
	}
	.ant-select-selector {
		${tw`shadow-sm`}
		border-radius: 12px !important;
		height: 50px !important;
		min-width: 15rem !important;
		border: 1px solid #dedef0 !important;
	}
	.ant-picker-input > input {
		padding-left: 30px;
	}
	.ant-radio {
		top: 0;
	}
	.ant-radio-wrapper {
		${tw`inline-flex items-center`}
		font-size: 12px;
		line-height: 21px;
		color: #323232;
		opacity: 0.7;

		.ant-radio-inner {
			${tw`h-6 w-6`}
			background: rgba(20, 20, 20, 0.06);
			border: 1px solid #ff5a62;
			&::after {
				content: "";
				background: #fff;
				border: 1px solid #ddd;
				display: inline-flex;
				align-items: center;
				justify-content: center;
				width: 16px;
				height: 16px;
				padding: 2px;
			}
		}
		.ant-radio-checked {
			background: #ff5a62 !important;
			border: 1px solid #ff5a62 !important;
			border-radius: 50%;
		}
	}
`;

const CouplesIntro = (props) => {
	const {
		handleFlow = () => {
			return null;
		},
	} = props;
	const history = useHistory();
	const dispatch = useDispatch();
	const weddingData = useSelector(getWedding);
	const [percentage, setPercentage] = useState(8);
	const [questions, setQuestions] = useState(1);
	const [subFlow, setSubFlow] = useState("about");
	const [selectedLink, setSelectedLink] = useState("");
	const [customUrl, setCustomUrl] = useState({ link: "", selected: true });
	const [gender, setGender] = useState("groom");
	// const [md, setMd] = useState("");
	const [wd, setWd] = useState("");
	const [msg, setMsg] = useState("");
	const [urlError, setUrlError] = useState(false);
	const [unique, setUnique] = useState(false);
	const { Option } = Select;

	const [couple, setCouple] = useState({
		fn: "",
		ln: "",
		pfn: "",
		pln: "",
	});

	const [fields, setFields] = useState({
		role: gender,
		date: "",
		venue: "",
		hashtag: "",
		bride_firstname: "",
		bride_lastname: "",
		groom_firstname: "",
		groom_lastname: "",
		venue_description: "",
		estimated_size: "",
		color_code: "",
		page_url: "",
		gmt_timezone: undefined,
	});

	console.log(fields);

	const { mutateAsync: handleSwitch, isLoading: switchLoading } =
		useMutation(switchExperience);
	const handleSkip = async () => {
		const data = {
			experience: "guest",
		};
		try {
			const response = await handleSwitch(data);
			console.log("\nswitch experience res: =====>\n", response.data);
			const { hasError } = response.data;
			if (hasError) {
				return Toast.fire({
					icon: "error",
					title: response.data.message,
				});
			}
			setTimeout(() => {
				history.push({ pathname: ROUTES.DASHBOARD });
			}, 750);
		} catch (err) {
			console.log("Error: ", err);
		}
	};

	useEffect(() => {
		dispatch(getTimezone());
		// eslint-disable-next-line
	}, []);

	// Handle Names
	useEffect(() => {
		if (gender === "groom") {
			setFields({
				...fields,
				groom_firstname: couple.fn,
				groom_lastname: couple.ln,
				bride_firstname: couple.pfn,
				bride_lastname: couple.pln,
			});
		} else {
			setFields({
				...fields,
				groom_firstname: couple.pfn,
				groom_lastname: couple.pln,
				bride_firstname: couple.fn,
				bride_lastname: couple.ln,
			});
		}

		// eslint-disable-next-line
	}, [
		gender,
		couple.fn,
		couple.pfn,
		couple.ln,
		couple.pln,
		weddingData.gmt_timezone,
	]);
	const handleNames = (e) => {
		e.preventDefault();
		if (
			isEmpty(couple.pfn) ||
			isEmpty(couple.pln) ||
			isEmpty(couple.fn) ||
			isEmpty(couple.ln)
		) {
			Toast.fire({
				icon: "error",
				title: `All fields are required`,
			});
			return;
		}

		// setSubFlow("meet");
		setSubFlow("date");
		handleAddPercent();
	};

	// Wedding date and venue
	useEffect(() => {
		setFields({ ...fields, date: dayjs(wd).format() });
		// eslint-disable-next-line
	}, [wd]);
	const handleWedding = (e) => {
		e.preventDefault();
		if (
			isEmpty(fields.date) ||
			isEmpty(fields.gmt_timezone) ||
			isEmpty(fields.venue)
		) {
			Toast.fire({
				icon: "error",
				title: `All fields are required`,
			});
			return;
		}
		setSubFlow("guest");
		handleAddPercent();
	};

	// Wedding guest and hashtag
	const handleGuest = (e) => {
		e.preventDefault();
		if (isEmpty(fields.hashtag.trim()) || isEmpty(fields.hashtag)) {
			Toast.fire({
				icon: "error",
				title: `All fields are required`,
			});
			return;
		}
		if (isEmpty(fields.estimated_size.trim())) {
			Toast.fire({
				icon: "error",
				title: `All fields are required`,
			});
			return;
		}
		setSubFlow("website");
		handleAddPercent();
	};

	//SETTING Wedding url
	useEffect(() => {
		const credentiails = {
			brideFirstname: fields.bride_firstname,
			groomFirstname: fields.groom_firstname,
		};
		subFlow === "website" && dispatch(fetchWeddingUrls(credentiails));
		// eslint-disable-next-line
	}, [subFlow, fields.bride_firstname, fields.groom_firstname]);

	useEffect(() => {
		customUrl.selected && !isEmpty(customUrl.link)
			? setFields({ ...fields, page_url: customUrl.link })
			: setFields({ ...fields, page_url: selectedLink });
		// eslint-disable-next-line
	}, [customUrl.selected, customUrl.link, selectedLink]);

	const { mutateAsync: getWeddingUrl, isLoading: urlLoading } =
		useMutation(checkUrl);
	const handleCustomUrl = async (data) => {
		try {
			const response = await getWeddingUrl(data);
			console.log(
				"\nWedding url validation res: =====>\n",
				response.data
			);
			const { hasError } = response.data;
			if (hasError) {
				setUnique(false);
				setUrlError(true);
				return setMsg(response.data.message);
			}
			console.log(response.data.data);
			const { is_unique } = response.data.data;
			setUnique(is_unique);
			if (is_unique) {
				setUrlError(false);
				setMsg("URL is available 👍");
			} else {
				setUrlError(true);
				setMsg("This URL is already taken/ unavailable 😔");
			}
		} catch (err) {
			console.log("Error: ", err);
		}
	};

	// handle submit
	const { mutateAsync: create, isLoading: createLoading } =
		useMutation(createWedding);
	const handleFinish = async (e) => {
		e.preventDefault();
		if (isEmpty(fields.page_url.trim())) {
			Toast.fire({
				icon: "error",
				title: `All fields are required`,
			});
			return;
		}
		try {
			const response = await create(fields);
			console.log("\nCreate wedding res: =====>\n", response.data);
			const { hasError } = response.data;
			if (hasError) {
				setUnique(false);
				setUrlError(true);
				return setMsg(response.data.message);
			}
			Toast.fire({
				icon: "success",
				title: `Account setup successfully`,
			});
			setTimeout(() => {
				history.push(ROUTES.DASHBOARD);
			}, 2000);
		} catch (err) {
			console.log("Error: ", err);
		}
	};

	// console.log("\n ==========I am the wedding data=========\n", weddingData);
	const handlePrevious = () => {
		switch (subFlow) {
			// case "meet":
			// 	setSubFlow("about");
			// 	break;
			case "date":
				setSubFlow("about");
				break;
			case "guest":
				setSubFlow("date");
				break;
			case "website":
				setSubFlow("guest");
				break;
			default:
				break;
		}
	};

	// Setting up step counter for progressbar
	React.useEffect(() => {
		const totalQuestions = 4.2;
		const percent = (questions / totalQuestions) * 100;
		setPercentage(percent);
	}, [questions]);

	const handleAddPercent = () => {
		setQuestions(questions + 1);
	};
	const handleMinusPercent = () => {
		subFlow === "about"
			? handleFlow("welcome")
			: setQuestions(questions - 1);
	};
	// Set default timezone
	const defaultTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
	useEffect(() => {
		if (isEmpty(weddingData?.timezone)) {
			return;
		}
		weddingData?.timezone.map((zone, i) => {
			if (
				// eslint-disable-next-line
				fields.gmt_timezone === undefined &&
				defaultTimezone === zone.timezone_name
			) {
			}
			return (
				defaultTimezone === zone.timezone_name &&
				setFields({
					...fields,
					gmt_timezone: zone.gmt_timezone,
				})
			);
		});
		// eslint-disable-next-line
	}, [fields.gmt_timezone, weddingData?.timezone]);

	return (
		<Wrapper>
			<div tw="flex flex-row items-center justify-between mb-2">
				<ArrowLeftOutlined
					tw="p-3 bg-gray-100 rounded-full hover:bg-white"
					onClick={() => {
						handlePrevious();
						handleMinusPercent();
					}}
				/>
				<Popconfirm
					placement="bottom"
					title={`Skip this process?`}
					onConfirm={() => handleSkip()}
					okText="Proceed"
					cancelText="Cancel">
					<span tw="text-appPink font-semibold cursor-pointer hover:text-appPinkSaturated">
						Do this later
					</span>
				</Popconfirm>
			</div>
			<div tw="w-full mb-8">
				<Progress
					strokeColor="black"
					percent={percentage}
					showInfo={false}
				/>
			</div>

			{subFlow === "about" && (
				<div>
					<h4 tw="font-bold text-4xl">Let’s know you</h4>
					<div>
						<img src={boy_girl} alt="" tw="w-48 h-24" />
					</div>
					{/* <form tw="pt-4"> */}
					<div tw="mt-4 flex flex-col">
						<Radio.Group name="radiogroup" defaultValue={gender}>
							<Radio
								value={"groom"}
								onChange={(e) => setGender(e.target.value)}>
								Groom
							</Radio>
							<Radio
								value={"bride"}
								onChange={(e) => setGender(e.target.value)}>
								Bride
							</Radio>
						</Radio.Group>
					</div>
					<div tw="mt-4">
						<label htmlFor="name" className="label">
							Your Name
						</label>
						<div className="form-control">
							<Input
								placeholder="First Name"
								type="text"
								css={inputStyle}
								value={couple.fn}
								onChange={(e) =>
									setCouple({
										...couple,
										fn: e.target.value,
									})
								}
								tw="w-full md:w-6/12"
								prefix={<img src={user} alt="" tw="pr-2" />}
							/>
							<Input
								placeholder="Last Name"
								type="text"
								value={couple.ln}
								onChange={(e) =>
									setCouple({
										...couple,
										ln: e.target.value,
									})
								}
								css={inputStyle}
								tw="w-full md:w-6/12"
								prefix={<img src={user} alt="" tw="pr-2" />}
							/>
						</div>
					</div>

					<div tw="mt-6">
						<label htmlFor="name" className="label">
							Your Partner’s Name
						</label>
						<div className="form-control">
							<Input
								placeholder="First Name"
								type="text"
								css={inputStyle}
								value={couple.pfn}
								onChange={(e) =>
									setCouple({
										...couple,
										pfn: e.target.value,
									})
								}
								tw="w-full md:w-6/12"
								prefix={<img src={user} alt="" tw="pr-2" />}
							/>
							<Input
								placeholder="Last Name"
								type="text"
								value={couple.pln}
								onChange={(e) =>
									setCouple({
										...couple,
										pln: e.target.value,
									})
								}
								css={inputStyle}
								tw="w-full md:w-6/12"
								prefix={<img src={user} alt="" tw="pr-2" />}
							/>
						</div>
					</div>

					<div tw="mt-20 mb-8">
						<button css={btnStyle} onClick={handleNames}>
							Next
						</button>
					</div>
					{/* </form> */}
				</div>
			)}

			{subFlow === "date" && (
				<div tw="mb-8">
					<h4 tw="font-bold text-4xl">
						Chosen a wedding date? <br />
						What’s your big day?
					</h4>

					<div tw="mt-4">
						<label htmlFor="name" className="label">
							Date
						</label>

						<div tw="relative">
							<div tw="absolute top-0 left-0 z-10">
								<img
									src={calender}
									alt=""
									tw="pr-2 absolute inset-3"
								/>
							</div>
							<DatePicker
								css={inputStyle}
								tw="w-full  md:w-9/12"
								suffixIcon={""}
								value={wd}
								disabledDate={(current) => {
									return current && current < moment();
								}}
								onChange={(date) => setWd(date)}
							/>
						</div>

						<Select
							showSearch
							placeholder="Select your timezone"
							value={fields.gmt_timezone}
							tw="w-full mt-4 md:w-9/12"
							onChange={(value) =>
								setFields({ ...fields, gmt_timezone: value })
							}>
							{weddingData?.timezone.map((zone, i) => {
								return (
									<Option value={zone.gmt_timezone} key={i}>
										{zone.gmt_timezone}
									</Option>
								);
							})}
						</Select>
					</div>

					<div tw="mt-6">
						<label htmlFor="name" className="label">
							Where
						</label>
						<div className="form-control">
							<Input
								placeholder="Location"
								type="text"
								value={fields.venue}
								onChange={(e) =>
									setFields({
										...fields,
										venue: e.target.value,
									})
								}
								css={inputStyle}
								tw="w-full md:w-9/12"
								prefix={<img src={location} alt="" tw="pr-2" />}
							/>
						</div>
					</div>

					<div tw="mt-16">
						<button css={btnStyle} onClick={handleWedding}>
							Next
						</button>
					</div>
				</div>
			)}

			{subFlow === "guest" && (
				<div tw="mb-8">
					<div>
						<h4 tw="font-bold text-4xl">
							Awesome! What’s your estimated guest size?
						</h4>
						<div tw="mt-4">
							<label htmlFor="name" className="label">
								Estimated guest size
							</label>
							<div className="form-control">
								<Input
									placeholder="0-100"
									type="text"
									value={fields.estimated_size}
									onChange={(e) =>
										setFields({
											...fields,
											estimated_size: e.target.value,
										})
									}
									css={inputStyle}
									tw="w-full md:w-9/12"
									prefix={<img src={user} alt="" tw="pr-2" />}
								/>
							</div>
						</div>
					</div>

					<h4 tw="font-bold text-4xl pt-12">
						What’s your preferred hashtag #?
					</h4>
					<div tw="mt-4">
						<label htmlFor="name" className="label">
							Enter an hashtag for the day
						</label>
						<div className="form-control">
							<Input
								placeholder="#yourhashtag"
								type="text"
								value={fields.hashtag}
								onChange={(e) =>
									setFields({
										...fields,
										hashtag: e.target.value.trim(),
									})
								}
								css={inputStyle}
								tw="w-full md:w-9/12"
							/>
						</div>
					</div>

					<div tw="mt-16">
						<button css={btnStyle} onClick={handleGuest}>
							Next
						</button>
					</div>
				</div>
			)}

			{subFlow === "website" && (
				<div tw="mb-12">
					<h4 tw="font-bold text-4xl">
						Choose your wedding <br /> website page URL.
					</h4>
					<div tw="mt-4">
						<p tw="text-lg font-semibold">
							Use this link you to connect to your guests
						</p>
					</div>

					<div tw="mt-8">
						<p tw="text-base text-appPink">
							<b>
								{!isEmpty(fields.page_url) &&
									fields.page_url + "."}
							</b>
							weddingstory.ng/
						</p>
						<div>
							{weddingData?.urls.map((url, index) => {
								return (
									<div
										key={index}
										css={inputStyle}
										onClick={() => {
											setSelectedLink(url);
											setCustomUrl({
												...customUrl,
												selected: false,
											});
										}}
										tw="w-full bg-white! placeholder-appTextDark! cursor-default text-sm! flex flex-row justify-between"
										// disabled
									>
										<span>{url}</span>{" "}
										{selectedLink === url ? (
											<ArrowRightOutlined tw="px-2 py-3.5 -mt-1 bg-appPink rounded-full text-sm text-white flex items-center justify-center" />
										) : (
											<span tw="p-3 border rounded-full border-appTextFaded! border-solid shadow-lg" />
										)}
									</div>
								);
							})}

							<Input
								placeholder="Create custom link"
								value={customUrl.link}
								type="text"
								onBlur={() => {
									!isEmpty(customUrl.link) &&
										handleCustomUrl(customUrl.link);
									isEmpty(customUrl.link) && setMsg("");
								}}
								onChange={(e) => {
									setCustomUrl({
										...customUrl,
										link: e.target.value.trim(),
										selected: true,
									});
									setSelectedLink("");
									setMsg("");
									setUrlError(false);
								}}
								css={inputStyle}
								tw="w-full bg-white! placeholder-appTextDark! cursor-default mb-0!"
								// disabled
								suffix={
									!isEmpty(customUrl.link) ? (
										<ArrowRightOutlined tw="p-2 bg-appPink rounded-full text-sm text-white flex items-center justify-center" />
									) : (
										<span tw="p-3 border rounded-full border-appTextFaded! border-solid shadow-lg" />
									)
								}
							/>
							{customUrl.selected ? (
								!unique && urlError ? (
									<span tw="text-appPinkSaturated text-xs font-bold">
										{msg}
									</span>
								) : (
									<span tw="text-appGreenGauze text-xs font-bold">
										{msg}
									</span>
								)
							) : (
								""
							)}
						</div>
					</div>

					<div tw="mt-8 mb-8">
						<button css={btnStyle} onClick={handleFinish}>
							{createLoading ? <Loading /> : "Next"}
						</button>
					</div>
				</div>
			)}
			{(switchLoading || urlLoading || createLoading) && <PageLoading />}
		</Wrapper>
	);
};

export default CouplesIntro;
